import creditEngineRepository, { CreditEngineRepository } from "./CreditEngineRepository";

const APPLICATION_JSON = "application/json";

const resource = "/otp";
export default {
  verify(phoneNumber, otp) {
    const body = {
      phoneNumber: phoneNumber,
      otp: otp
    };

    creditEngineRepository.setContentType(APPLICATION_JSON);
    return CreditEngineRepository.put(`${resource}/verify`, body);
  },

  generateOTP(phoneNumber) {
    const body = { mobileNo: phoneNumber };

    creditEngineRepository.setContentType(APPLICATION_JSON);
    return CreditEngineRepository.post(`${resource}`, body);
  },

  getOTPVerificationStatus(otpId) {
    const body = { id: otpId };
    creditEngineRepository.setContentType(APPLICATION_JSON);
    return CreditEngineRepository.post(`${resource}/verify`, body);
  }
};
